import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSeo, SUBURBS, REGIONS } from "@/lib/site";
import { Reveal, MaskLines } from "@/components/Reveal";

export default function Areas() {
  useSeo("Service Areas — Breeze Block Supply & Install Across Sydney | Breeze Craft", "We deliver and install breeze blocks across Greater Sydney: Eastern Suburbs, Northern Beaches, Inner West, North Shore, Shire and more.");
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14 sm:py-20" data-testid="areas-page">
      <p className="kicker mb-4">Service areas</p>
      <h1 className="font-display text-4xl sm:text-6xl font-medium tracking-tight text-ink" data-testid="areas-heading">
        <MaskLines lines={["All of Sydney,", "coast to hills."]} />
      </h1>
      <Reveal delay={0.2} className="mt-5 max-w-2xl">
        <p className="text-neutral-600 leading-relaxed">
          Our crews run out of a central Sydney yard and cover all of Greater Sydney. Delivery runs hit every region at least twice a week.
        </p>
      </Reveal>

      <Reveal delay={0.25} className="mt-10 flex flex-wrap gap-2" data-testid="areas-region-tags">
        {REGIONS.map((r) => (
          <span key={r} className="border border-ink/15 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-neutral-600">{r}</span>
        ))}
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10" data-testid="areas-grid">
        {SUBURBS.map((s, i) => (
          <Reveal key={s.slug} delay={Math.min(i * 0.04, 0.4)}>
            <Link to={`/areas/${s.slug}`} data-testid={`area-card-${s.slug}`} className="group flex items-center justify-between bg-bone p-6 h-full">
              <div>
                <p className="font-display text-xl font-medium text-ink group-hover:text-terracotta transition-colors">Breeze Blocks {s.name}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500 mt-1">{s.region}</p>
              </div>
              <ArrowUpRight size={18} className="text-neutral-400 group-hover:text-terracotta transition-colors shrink-0" />
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 text-sm text-neutral-600 max-w-2xl leading-relaxed" data-testid="areas-note">
        Don't see your suburb? If it's in Greater Sydney we almost certainly cover it — put it in the{" "}
        <Link to="/quote" className="text-terracotta font-medium hover:underline">quote form</Link> and we'll confirm.
      </Reveal>
    </div>
  );
}
